// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dUHOY","description":"styles_description__40jY8","iosButton":"styles_iosButton__sCNW5","close":"styles_close__ITPKh"};